import { FC } from 'react';
import { ModalFooterProps } from '@chakra-ui/react';

import SunshineModal from 'components/_core/SunshineModal';

import CancelButton from './components/CancelButton';
import SubmitButton from './components/SubmitButton';

interface FooterParts {
  CancelButton: typeof CancelButton;
  SubmitButton: typeof SubmitButton;
}

const Footer: FC<ModalFooterProps> & FooterParts = (props) => (
  <SunshineModal.Footer {...props} />
);

Footer.CancelButton = CancelButton;
Footer.SubmitButton = SubmitButton;

export default Footer;
